import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";
import { API } from "./brand";

const AuthContext = createContext(null);
const TOKEN_KEY = "gra_user_token";

export const getUserToken = () => localStorage.getItem(TOKEN_KEY);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const t = localStorage.getItem(TOKEN_KEY);
    if (!t) { setLoading(false); return; }
    axios.get(`${API}/auth/me`, { headers: { Authorization: `Bearer ${t}` } })
      .then((r) => setUser(r.data))
      .catch(() => localStorage.removeItem(TOKEN_KEY))
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const r = await axios.post(`${API}/auth/login`, { email, password });
    if (r.data.code_required) {
      // 2FA pending — caller handles the next step
      return { codeRequired: true, email: r.data.email };
    }
    localStorage.setItem(TOKEN_KEY, r.data.token);
    setUser(r.data.user);
    return r.data.user;
  };

  const verifyLogin = async (email, code) => {
    const r = await axios.post(`${API}/auth/verify-login`, { email, code });
    localStorage.setItem(TOKEN_KEY, r.data.token);
    setUser(r.data.user);
    return r.data.user;
  };

  const register = async (email, password, name) => {
    const r = await axios.post(`${API}/auth/register`, { email, password, name });
    if (r.data.code_required) {
      return { codeRequired: true, email: r.data.email };
    }
    localStorage.setItem(TOKEN_KEY, r.data.token);
    setUser(r.data.user);
    return r.data.user;
  };

  const verifyRegister = async (email, code) => {
    const r = await axios.post(`${API}/auth/verify-register`, { email, code });
    localStorage.setItem(TOKEN_KEY, r.data.token);
    setUser(r.data.user);
    return r.data.user;
  };

  const resendCode = async (email, purpose) => {
    await axios.post(`${API}/auth/resend-code`, { email, purpose });
  };

  const logout = () => {
    localStorage.removeItem(TOKEN_KEY);
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, verifyLogin, register, verifyRegister, resendCode, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);

export const authHeaders = () => {
  const t = getUserToken();
  return t ? { Authorization: `Bearer ${t}` } : {};
};
